import { isPlatformAdmin, isPlatformUser, type UserType } from '../../contexts';
import { allPathNames, allPaths } from '../../routes/Paths';
import type { ReactElement } from 'react';

type TMenuItem = {
  title: string;
  path: string;
  icon: ReactElement;
};

const createMenuItems = (
  userType: UserType,
  excluded = ['LOGIN', 'LANDING_PAGE', 'NOT_FOUND_PAGE'],
  adminOnly = ['ADMIN_SETTINGS', 'ONBOARD_MERCHANT'],
  merchantOnly = [
    'APPLICATIONS',
    'SNPL',
    'PAYMENT_ASSIST',
    'COURSES',
    'REPORTING'
  ],
  platformUserOnly = ['ACCOUNTS']
) => {
  return allPathNames
    .filter((pathName) => !excluded.includes(pathName))
    .filter((pathName) => {
      if (isPlatformAdmin(userType)) {
        return pathName;
      }
      return !adminOnly.includes(pathName);
      // return userRole === 'admin' && !adminOnly.includes(pathName);
    })
    .filter((pathName) => {
      if (isPlatformAdmin(userType) || isPlatformUser(userType)) {
        return platformUserOnly.includes(pathName);
      }
      return merchantOnly.includes(pathName);
      // return userRole === 'admin' && !adminOnly.includes(pathName);
    })
    .map((pathName) => {
      const { title, path, icon } = allPaths[pathName];
      return { title, path, icon } as TMenuItem;
    });
};
// const { user } = useContext(UserContext);
// console.log('user', user);
const MenuItems = createMenuItems('unknown');
// const MenuItems = [
//   {
//     title: 'Landing Page',
//     path: '/',
//     icon: <FaIcons.FaHome />
//   },
//   {
//     title: 'Login Page',
//     path: '/login',
//     icon: <FaIcons.FaUsers />
//   },
//   {
//     title: 'Chats',
//     path: '/chats',
//     icon: <FaIcons.FaRocketchat />
//   },
//   {
//     title: 'User Details',
//     path: '/user-details',
//     icon: <FaIcons.FaRegChartBar />
//   }
// ];

export { MenuItems, createMenuItems };
